module.exports = __webpack_public_path__ + "280cda50eef36a2912919e9530382e8f.svg";